(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-bullets-media"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-steps-media]').forEach(function (root) {
      var steps = root.querySelectorAll('.b2b-stepsmedia__step');
      var image = root.querySelector('[data-steps-image]');
      if (!steps.length || !image) return;
      steps.forEach(function (step) {
        var btn = step.querySelector('.b2b-stepsmedia__step-btn');
        var activate = function () {
          steps.forEach(function (s) { s.classList.remove('is-active'); });
          step.classList.add('is-active');
          var newSrc = step.getAttribute('data-step-image');
          if (newSrc) {
            image.style.opacity = '0.4';
            setTimeout(function () { image.src = newSrc; image.style.opacity = '1'; }, 120);
          }
        };
        btn.addEventListener('click', activate);
        btn.addEventListener('mouseenter', activate);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-feature-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-feature-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-feature-tab]');
      var panels = root.querySelectorAll('[data-feature-panel]');

      function activate(index) {
        tabs.forEach(function (tab) {
          var isActive = tab.dataset.featureTab === String(index);
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });
        panels.forEach(function (panel) {
          var isActive = panel.dataset.featurePanel === String(index);
          panel.classList.toggle('is-active', isActive);
          if (isActive) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { activate(tab.dataset.featureTab); });
        tab.addEventListener('keydown', function (e) {
          var current = parseInt(tab.dataset.featureTab, 10);
          var max = tabs.length;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
            e.preventDefault();
            var next = current === max ? 1 : current + 1;
            activate(next);
            tabs[next - 1].focus();
          } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var prev = current === 1 ? max : current - 1;
            activate(prev);
            tabs[prev - 1].focus();
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-video-feature"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-b2b-video-player]').forEach(function (root) {
    var video = root.querySelector('video');
    var btn = root.querySelector('.b2b-video__play');
    if (!video || !btn) return;
    btn.addEventListener('click', function () {
      video.controls = true;
      video.play();
      root.classList.add('is-playing');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-who-we-help"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-whh-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-whh-tab]');
      var panels = root.querySelectorAll('[data-whh-panel]');
      function activate(index) {
        tabs.forEach(function (tab) {
          var isActive = tab.dataset.whhTab === String(index);
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });
        panels.forEach(function (panel) {
          var isActive = panel.dataset.whhPanel === String(index);
          panel.classList.toggle('is-active', isActive);
          if (isActive) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
        });
      }
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { activate(tab.dataset.whhTab); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
/*
  El header ya es position: fixed (ver .header en el style de esta seccion), asi
  que no necesita logica de scroll. Antes este componente escuchaba cada scroll,
  leia navbar.offsetTop (fuerza un recalculo de layout) y ponia la clase .sticky,
  que tambien es position: fixed: no cambiaba nada en pantalla. Se conserva el
  custom element para que <sticky-header> siga definido.
*/
class StickyHeader extends HTMLElement {}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
